package Utils

import myName

@myName("ChangeNoteHelper")
data class ChangeNoteHelper(val doc_id:Int,val docType:Int,val p_id:Int,val amount:Float,val amountSecond:Float,val conversion_rate:Float,val returns:Float,val price:Float,val discount:Float,val driver:String?=null,val date:String?=null,val cost:Float?=null)
